// ===================================
// FILE 1: cl-job-details-pop-up.component.ts
// ===================================

import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GenerateCvService } from 'src/app/pages/generate resume/generate-cv-steps/services/generate-cv/generate-cv.service';
import { GeneratedcvService } from '../services/generatedcv.service';

@Component({
  selector: 'app-cl-job-details-pop-up',
  templateUrl: './cl-job-details-pop-up.component.html',
  styleUrls: ['./cl-job-details-pop-up.component.css'],
})
export class ClJobDetailsPopUpComponent implements OnInit {
  @Input() isVisible: boolean = false;
  @Input() cvId: any;
  @Output() close = new EventEmitter<void>();
  @Output() generateCoverLetter = new EventEmitter<any>();

  isClosing: boolean = false;
  jobDetailsForm!: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private generatedcvService: GeneratedcvService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.initializeJobDetailsForm();
  }

  initializeJobDetailsForm() {
    this.jobDetailsForm = this.fb.group({
      jobTitle: [''],
      company: [''],
      jobDescription: [''],
    });
  }

  onClose(): void {
    this.isClosing = true;
    setTimeout(() => {
      this.jobDetailsForm.reset();
      this.loading = false;
      this.isClosing = false;
      this.close.emit();
    }, 300);
  }

  onGenerateCoverLetter(): void {
    this.loading = true;
    let userId: string | null = localStorage.getItem('userId');

    const jobDetails = this.jobDetailsForm.value;

    this.generatedcvService
      .generateCoverLetter(this.cvId, jobDetails)
      .subscribe({
        next: (res) => {
          this.onClose();
          this.router.navigate(['/profile/generated-cover-letters']);
        },
        error: (err) => {
          console.error('Error:', err);
          this.loading = false;
        },
      });
  }

  onOverlayClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('popup-overlay')) {
      this.onClose();
    }
  }
}
